export type TenantConfig = {
  id: string;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  primaryDomain?: string;
  logoUrl?: string;
  favicon?: string;
  webAppUrl?: string;
};

export const DEFAULT_TENANT_CONFIG: TenantConfig = {
  id: "",
  name: "Oze",
  primaryColor: "#0E37B9",
  secondaryColor: "#718CE6",
};
